import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=6b126998&scoped=true&"
import script from "./InputField.vue?vue&type=script&lang=ts&"
export * from "./InputField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b126998",
  null
  
)

export default component.exports